import { render, staticRenderFns } from "./UnassignOrderFromBdoCard.vue?vue&type=template&id=db13e872&"
import script from "./UnassignOrderFromBdoCard.vue?vue&type=script&lang=js&"
export * from "./UnassignOrderFromBdoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports